import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context';
import PortalShell from './PortalShell';

const THINGS = [
  {
    t: 'Signal',
    d: 'Put out a signal anywhere in the world. Any vetted member nearby can opt in to meet you, and you choose whether to say yes.',
  },
  {
    t: 'Give / Take Board',
    d: 'Offer what you’ve got, ask for what you need. We take care of each other.',
  },
  {
    t: 'Friends',
    d: 'Met someone worth befriending? Add them on Portal Noir, and the connection lives on long after the meet-up.',
  },
];

export default function PortalAboutPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleApplyClick = () => {
    navigate(isAuthenticated ? '/noir/apply' : '/login?redirect=/portal/apply');
  };

  return (
    <PortalShell>
      <div style={{ maxWidth: 720, margin: '90px auto 60px', padding: '0 24px' }}>
        <p className="portal-label" style={{ marginBottom: 14 }}>ABOUT PORTAL NOIR</p>
        <h1 className="portal-hero" style={{ marginBottom: 20 }}>Every encounter can change your life.</h1>
        <p className="portal-serif" style={{ fontStyle: 'italic', fontSize: 20, color: '#ECE7DA', marginBottom: 40 }}>
          That&rsquo;s why we call it a Portal Noir.
        </p>

        <p className="portal-prose" style={{ marginBottom: 56 }}>
          We gather for private dinners, coffee meets, late-night martinis, city wandering&mdash;sometimes more mischievous things.
        </p>

        <p className="portal-label" style={{ marginBottom: 24 }}>WHAT YOU CAN DO</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 28, marginBottom: 48 }}>
          {THINGS.map((it, i) => (
            <div key={it.t} style={{ display: 'flex', gap: 18, alignItems: 'baseline' }}>
              <span className="portal-mono portal-gold" style={{ fontSize: 12, flexShrink: 0, width: 24 }}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <div>
                <h3 className="portal-serif" style={{ fontSize: 22, color: '#ECE7DA', marginBottom: 8 }}>{it.t}</h3>
                <p className="portal-prose" style={{ margin: 0 }}>{it.d}</p>
              </div>
            </div>
          ))}
        </div>

        <button type="button" onClick={handleApplyClick} className="portal-btn">
          REQUEST A SEAT
        </button>
      </div>
    </PortalShell>
  );
}
